const MANAGED_ROLE_KEYWORDS = ['qa manager'];
const MANAGED_MENU_KEYWORDS = ['document', 'coa', 'ncr', 'workflow'];

const normalize = (value?: string | null): string => String(value || '').trim().toLowerCase();

export const isQaManagerRoleName = (roleName?: string | null): boolean => {
  const normalized = normalize(roleName);
  return MANAGED_ROLE_KEYWORDS.some((keyword) => normalized.includes(keyword));
};

const getMenuText = (menu: any): string => {
  return normalize([menu?.title, menu?.path, menu?.name].filter(Boolean).join(' '));
};

const isManagedMenuSelf = (menu: any): boolean => {
  const text = getMenuText(menu);
  return MANAGED_MENU_KEYWORDS.some((keyword) => text.includes(keyword));
};

export const getManagedMenuIdSet = (menus: any[]): Set<number> => {
  const menuMap = new Map<number, any>();
  menus.forEach((menu) => {
    if (menu && menu.id != null) {
      menuMap.set(Number(menu.id), menu);
    }
  });

  const memo = new Map<number, boolean>();

  const isManagedMenu = (menu: any): boolean => {
    if (!menu || menu.id == null) return false;

    const menuId = Number(menu.id);
    if (memo.has(menuId)) return memo.get(menuId) || false;

    if (isManagedMenuSelf(menu)) {
      memo.set(menuId, true);
      return true;
    }

    let parentId = menu.parentId != null ? Number(menu.parentId) : null;
    while (parentId != null && menuMap.has(parentId)) {
      const parent = menuMap.get(parentId);
      if (isManagedMenuSelf(parent)) {
        memo.set(menuId, true);
        return true;
      }
      parentId = parent?.parentId != null ? Number(parent.parentId) : null;
    }

    memo.set(menuId, false);
    return false;
  };

  const allowedIds = new Set<number>();
  menus.forEach((menu) => {
    if (menu && menu.id != null && isManagedMenu(menu)) {
      allowedIds.add(Number(menu.id));
    }
  });

  return allowedIds;
};

export const filterMenusByScope = (menus: any[], allowedMenuIds: Set<number>): any[] => {
  return menus.filter((menu) => menu && menu.id != null && allowedMenuIds.has(Number(menu.id)));
};

export const filterActionsByScope = (actions: any[], allowedMenuIds: Set<number>): any[] => {
  return actions.filter((action) => action && action.menuId != null && allowedMenuIds.has(Number(action.menuId)));
};
